import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import SmokeRavenNavbar from "./js/components/Navigation";
import { AuthProvider } from "./contexts/AuthContext";
import { WELCOME_EVENT_NAME } from "./js/components/auth/welcomeOverlayTrigger";

function PostLoginWelcomeOverlay() {
  const [visible, setVisible] = useState(false);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    const showOverlay = () => {
      if (hideTimerRef.current) {
        window.clearTimeout(hideTimerRef.current);
      }

      setVisible(true);
      hideTimerRef.current = window.setTimeout(() => {
        setVisible(false);
      }, 2600);
    };

    const handleWelcomeEvent = () => {
      showOverlay();
    };

    window.addEventListener(WELCOME_EVENT_NAME, handleWelcomeEvent);

    return () => {
      if (hideTimerRef.current) {
        window.clearTimeout(hideTimerRef.current);
      }
      window.removeEventListener(WELCOME_EVENT_NAME, handleWelcomeEvent);
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="welcome-overlay"
      role="status"
      aria-live="polite"
      aria-label="Welcome overlay"
    >
      <div className="welcome-overlay__card">
        <div className="welcome-overlay__dice" aria-hidden="true">
          <span className="pip pip--1" />
          <span className="pip pip--2" />
          <span className="pip pip--3" />
          <span className="pip pip--4" />
          <span className="pip pip--5" />
          <span className="pip pip--6" />
        </div>
        <h3 className="welcome-overlay__title">Welcome!</h3>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <SmokeRavenNavbar />
        <PostLoginWelcomeOverlay />
      </div>
    </AuthProvider>
  );
}

export default App;
